import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ppa-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  anoSistema = new Date().getFullYear();
  constructor() { }

  ngOnInit() {
  }

}
